import React from "react";
import {observer} from "mobx-react";
import {Space, Table, Typography} from "antd";
import {useArticle} from "../../../article.context";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {columnsFactory} from "./article.data.analogues.columns";

export const ArticleDataAnalogues: React.FC = observer(() => {
    const {article} = useArticle();
    const t = useTranslate();
    const columns = columnsFactory(t);

    return (
        <Space direction={"vertical"} size={0}>
            <Typography.Title level={3}>{t("ARTICLES.ANALOGUES")}</Typography.Title>
            <Table
                columns={columns}
                rowKey={"id"}
                dataSource={[...article.analogues]}
                scroll={{x: true}}
                pagination={false}
            />
        </Space>
    );
})
